// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".m3tSfi5CehXZ5XfF84U8{font-weight:500}.m3tSfi5CehXZ5XfF84U8:hover{text-decoration:underline}", "",{"version":3,"sources":["webpack://./src/pages/cp/conversations/aiAssistant/history/index.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CAEA,4BACE,yBAAA","sourcesContent":[".tableEmail {\n  font-weight: 500;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableEmail": "m3tSfi5CehXZ5XfF84U8"
};
export default ___CSS_LOADER_EXPORT___;
